import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  ContainerPrincipal,
} from './RendimentoMensalComercialStyles';

function RendimentoMensalComercialComponent() {
  return (
    <ContainerPrincipal>
      <p>Aguarde!  Opção em desenvolvimento</p>
    </ContainerPrincipal>
  );
}

export const RendimentoMensalComercial = withRouter(RendimentoMensalComercialComponent);
